
import {Directive, forwardRef, Injectable} from "@angular/core";
import {AbstractControl, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {of} from "rxjs";
import {first, map} from "rxjs/operators";
import {ValidationbirthdayService} from "src/app/shared/services/validationbirthday/validationbirthday.service";
import {IdentificationService} from "./identification.service";
import {ProjectOpenapiCastService} from "build/project/openapi-cast/project/project-openapi-cast.service";
import {IIdentifier, ResponseCheckCodeWithBirthday} from "build/project/openapi-cast/project/project-openapi-cast.model";

@Injectable({
   providedIn: "root"
})

export class CodeBirthdayValidationService implements Validator {
   constructor (private sProjectOpenapi: ProjectOpenapiCastService, public sValidationBirthday: ValidationbirthdayService, private sIdentification: IdentificationService) {}
  
   private errorC: ValidationErrors | undefined;
   private identifier: IIdentifier | undefined;
   public validatorFunction: AsyncValidatorFn = (control) => this.isBirthdayValid(control) ? control?.value !== "" && this.sValidationBirthday.birthday && this.checkToggleValid(control)
      ? (this.checkIdentifier(control) ? this.sProjectOpenapi.checkCodeWithBirthday(<IIdentifier>this.identifier)
         .pipe(
            map(value => this.isCodeBirthdayValid({code: value.code!}, <IIdentifier>this.identifier, control)),
            first()
         ) : of(<ValidationErrors>this.errorC))
      : of(null)
      : of(<ValidationErrors>this.errorC);
  
   validate (control: AbstractControl) {

      return this.validatorFunction(control);
   }

   private checkToggleValid (control: AbstractControl): boolean {
      control.parent?.get('toggle')?.updateValueAndValidity({emitEvent: false, onlySelf: true});
      return control.parent?.get('toggle')?.valid ? control.parent?.get('toggle')?.dirty ? true : false : false;
   }

   private checkIdentifier (control: AbstractControl): boolean {

      const uuid: string = control.parent?.get('formControlUuid')?.value;
      const birthday: string = control.value.format("DD.MM.yyyy");

      if (!uuid || uuid == '') {
         this.errorC = {uuidIsEmpty: true};
         return false;
      }

      if (!birthday || birthday == '') {
         this.errorC = {birthdayIsEmpty: true};
         return false;
      }

      this.identifier = {
         code: uuid,
         birthday: birthday
      };
      return true;
   }

   private isBirthdayValid (control: AbstractControl): boolean {
      if (this.sIdentification.birthdayPattern) {
         const value: string = control.parent?.get('formControlBirthday')?.value.format("DD.MM.yyyy");
         const regExp: RegExp = new RegExp(this.sIdentification.birthdayPattern, 'g');
         if (!regExp.test(value)) {
            control.parent?.get('formControlBirthday')?.setErrors({birthdayWrongFormat: true});
            this.errorC = {birthdayWrongFormat: true};
            return false;
         }
      }

      control.parent?.get('formControlBirthday')?.setErrors({});
      this.errorC = { };

      return true;
   }

   private isCodeBirthdayValid (value: ResponseCheckCodeWithBirthday, identifier: IIdentifier, control: AbstractControl): ValidationErrors | null {
      if (value && value.code && value.code == identifier.code) {
         control.parent?.get('formControlUuid')?.setErrors(null);
         return null;
      } else {
         control.parent?.get('formControlBirthday')?.setErrors({birthdayNotExists: true}) ;
         return {birthdayNotExists: true};
      }
   }
}

@Directive({
   selector: '[BirthdayIsValid][formControlName]',
   providers: [
      {
         provide: NG_ASYNC_VALIDATORS,
         useExisting: forwardRef(() => CodeBirthdayValidationService),
         multi: true
      }
   ],
   standalone: false
})
 
export class CheckBirthdayValidationDirective { }
